import { Collapse } from '@mui/material';
import React from 'react';
import { useCreatePlanContext } from '../../../../../contexts/create-plan-context';
import type { PlanCreationStep } from '../../../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { CreatePlanLivePreview } from '../CreatePlanLivePreview/CreatePlanLivePreview';

type NewCreatePlanPageContentProps = {
  stepsContent: Record<
  PlanCreationStep,
  React.ReactElement
  >;
};

// TODO: When CreatePlanPageContent would be deprecated due new design, remove that file and change this file to CreatePlanPageContent.tsx
export const NewCreatePlanPageContent: React.FC<
NewCreatePlanPageContentProps
> = ({ stepsContent }) => {
  const {
    planCreationStepper: { currentStep },
    planPreview: { open, hide },
  } = useCreatePlanContext();

  return (
    <div className="flex h-full w-full overflow-y-hidden bg-[#F6F9FA]">
      <div className="flex-1 overflow-y-auto px-6 pb-6 pt-4">
        {stepsContent[currentStep]}
      </div>

      <Collapse
        in={open}
        orientation="horizontal"
        sx={{
          height: '100%',
        }}
      >
        <CreatePlanLivePreview
          title="Plan Preview"
          onHide={hide}
        />
      </Collapse>
    </div>
  );
};
